export default {
  club_name: 'Nesso Business Club',
  club_name_short: 'nesso',
  stadium_name: '',
  staging_url: 'https://nesso.api.fangroup.io',
  prod_url: 'https://nesso.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/nesso',
  club_logo: '/assets/teams/nesso.png',
  app_name: 'nesso',
  websale_name: 'nesso',
  ntb_team_id: 10068,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'nesso',
  monolithEnabled: false,
  clubWebsiteEnabled: true,
};
